// Cửa phòng ban chỉ mở cho người LÀM việc của phòng — bản sao
// `deptWriteDoorClosed` ở máy chủ (backend/internal/platform/auth/policy.go).
//
// Máy chủ mở một số cửa GHI theo phòng ban (thu tiền, két, sổ Tiếng khách,
// đơn in…) để nhân viên vai `staff` làm được việc của phòng. Rà soát
// 28/09/2026: vai chỉ-xem, QC, quản lý vùng mang phòng "reception"/"accounting"
// từng đi thẳng qua các cửa đó. Máy chủ nay chặn họ ở mọi yêu cầu GHI; màn phải
// ẩn nút tương ứng, không để hiện ra rồi 403. Cửa ĐỌC không đổi.
import { ROLE } from "./roles";

const DEPT_WRITE_CLOSED_ROLES = new Set<string>([
  ROLE.Viewer,
  ROLE.QC,
  ROLE.AreaManager,
  ROLE.ShiftLead,
  ROLE.Coordinator,
]);

/** Vai này KHÔNG được ghi qua cửa phòng ban (thiếu vai coi như bị đóng). */
export function deptWriteDoorClosed(role: string | null | undefined): boolean {
  return DEPT_WRITE_CLOSED_ROLES.has((role ?? "").trim().toLowerCase());
}
